import {
    deleteFilesDriverLoading,
    deleteFilesDriverRequest,
    deleteFilesDriverSuccess,
    deleteFilesDriverReject,
    deleteFilesDriverReset
} from "../../actions/filesDriver/delete";

export const deleteFilesDriver = (formData) => async (dispatch, getState) => {
    dispatch(deleteFilesDriverLoading());
    try {
        const { data } = await deleteFilesDriverRequest(formData, getState);
        dispatch(deleteFilesDriverSuccess(data))
    } catch (error) {
        dispatch(deleteFilesDriverReject(error))
    } finally {
        setTimeout(() => { dispatch(deleteFilesDriverReset()) }, 3000);
    }
    return Promise.resolve();
};